const $html = $('html');

function init(elements) {
    $(elements).each((i, el) => {
        const $el= $(el);

        const config = $el.data('toggle') || {};
        const {
            ns = '',
            activeClass = 'is-active',
            htmlClass = '',
            showEffect = 'toggle',
            slideTime = 0,
            clickOverlay = true
        } = config;
        const $button = $(`[data-toggle-button="${ns}"]`);
        const $block = $(`[data-toggle-block="${ns}"]`);
        const $bg = $(`[data-toggle-bg="${ns}"]`);

        const open = function () {
            $el.addClass(activeClass);
            $button.addClass(activeClass);
            $block.addClass(activeClass);
            if (htmlClass) {
                $html.addClass(htmlClass);
            }

            if ($button.hasClass('search-button')) {
                $('[data-search-input]').focus();
            }
        };
        const close = function () {
            $el.removeClass(activeClass);
            $button.removeClass(activeClass);
            $block.removeClass(activeClass);
            if (htmlClass) {
                $html.removeClass(htmlClass);
            }
        };
        const isOpen = function () {
            return $el.hasClass(activeClass);
        };
        const openHandler = function () {
            if (showEffect === 'slide' && slideTime > 0) {
                $block.stop(false, true).slideUp(slideTime, open);
            } else {
                open();
            }
        };
        const closeHandler = function () {
            if (showEffect === 'slide' && slideTime > 0) {
                $block.stop(false, true).slideUp(slideTime, close);
            } else {
                close();
            }
        };

        $button.on('click', function () {
            if (isOpen()) {
                closeHandler();
            } else {
                openHandler();
            }
        });

        $bg.on('click', function () {
            closeHandler();
        });

        if (clickOverlay) {
            $(document).on('click', function (event) {
                if (
                    !$el.find(event.target).length &&
                    (!$button.length || !$button.find(event.target).length) &&
                    (!$block.length || !$block.find(event.target).length)
                ) {
                    closeHandler();
                }
            });
        }
    });


}

export default function ($elements) {
    init($elements);
}